import React from 'react'
import { Nav, Navbar, Container, Image } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import logo1 from '../../images/Seeding Brains UI/logo.png'
import newsIcon from '../../assets/home-images/sn-bg.png'

const Header = () => {
  return (
    <>
      <div className='header1'>
        <Navbar bg='blue' expand='lg'>
          <Container>
            <Navbar.Brand>
              <NavLink to='/'>
                <img src={logo1} className='img-fluid' alt='logo' />
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls='basic-navbar-nav' />
            <Navbar.Collapse id='basic-navbar-nav'>
              <Nav className='ms-auto'>
                <NavLink exact='true' className='nav-link' to='/'>
                  Home
                </NavLink>
                <NavLink to='/news' className='nav-link'>
                  <Image src={newsIcon} width={30} />ED-News
                </NavLink>
                <NavLink to='/htbd' className='nav-link'>
                  HTBD
                </NavLink>
                <NavLink to='/guest-lecture' className='nav-link'>
                  Guest Lecture
                </NavLink>
              </Nav>
              {/* <Form className='d-flex'>
                <Form.Control
                  type='search'
                  placeholder='Search'
                  className='me-2 search-input'
                  aria-label='Search'
                />
              </Form> */}
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  )
}

export default Header
